import fc from "@/firebaseConfig";
import moment from 'moment';

const _ = require('lodash');

// import docs from "@/store/collection/docs";

export default {
  namespaced: true,
  state: {
    selectedDayOrWeek: 'day',
    selectedSummaryDate: {id: "", salesAmount: 0, salesTaxAmount: 0},
    selectedYearMonth: "",
    summaryMonth: {salesAmount: 0, salesTaxAmount: 0},
    summaryAll: null,
    dateInMonth: [{salesAmount: 0, salesTaxAmount: 0}],
    chartData: {
      labels: ['1-7', '8-14', '15-21', '22-28', '28-31'],
      datasets: [
        {
          label: '',
          borderWidth: 4,
          backgroundColor: 'rgb(0, 0, 0, 0)',
          pointHoverBorderColor: 'transparent',
          borderColor: 'rgb(110, 195, 155, 1)',
          data: [0, 0, 0, 0, 0],
          pointStyle: false,
          hoverRadius: 0,
          radius: 0

        },
        {
          label: '',
          borderWidth: 4,
          backgroundColor: 'rgb(200, 79, 153, 0.3)',
          borderColor: 'rgb(200, 79, 153, 1)',
          data: [0, 0, 0, 0, 0],
          PointStyle: false,
          hoverRadius: 0,
          radius: 0

        }
      ]
    },
    chartDayData: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      datasets: [
        {
          label: '',
          borderWidth: 4,
          backgroundColor: 'rgb(0, 0, 0, 0)',
          borderColor: 'rgb(110, 195, 155, 1)',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          pointStyle: false,
          hoverRadius: 0,
          radius: 0

        },
        {
          label: '',
          borderWidth: 4,
          backgroundColor: 'rgb(200, 79, 153, 0.3)',
          borderColor: 'rgb(200, 79, 153, 1)',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          pointStyle: false,
          hoverRadius: 0,
          radius: 0

        }
      ]
    },
    mSummaryMonthUnsubscribeObject: null,
    mSummaryAllUnsubscribeObject: null,
    mSummaryDayFirstUnsubscribeObject: null,
    mSummaryDaySecondUnsubscribeObject: null,
  },
  mutations: {
    setSelectedSummaryDate(state, val) {
      state.selectedSummaryDate = val
    },
    setSelectedYearMonth(state, val) {
      state.selectedYearMonth = val
    },
    setSummaryMonth(state, val) {
      state.summaryMonth = val
    },
    setSummaryAll(state, val) {
      state.summaryAll = val
    },
    setPreWeekData(state, payload) {
      let objectTmp = _.cloneDeep(state.chartData)
      objectTmp.datasets[0].data = payload.mainChartData
      objectTmp.datasets[1].data = payload.datePreArray
      state.chartData = objectTmp
    },
    setPreDayData(state, payload) {
      let objectTmp = _.cloneDeep(state.chartDayData)
      objectTmp.datasets[0].data = payload.mainChartData
      objectTmp.datasets[1].data = payload.datePreArray
      state.chartDayData = objectTmp
    },
    setNotPreDayData(state, val) {
      let objectTmp = _.cloneDeep(state.chartDayData)
      objectTmp.datasets[0].data = val
      objectTmp.datasets[1].data = []
      state.chartDayData = objectTmp
    },
    setNotPreWeekData(state, val) {
      let objectTmp = _.cloneDeep(state.chartData)
      objectTmp.datasets[0].data = val
      objectTmp.datasets[1].data = []
      state.chartData = objectTmp
    },
    setSelectedDayOrWeek(state, val) {
      state.selectedDayOrWeek = val
    },
  },
  actions: {
    setSelectedSummaryDate({commit}, {summaryDate}) {
      commit('setSelectedSummaryDate', summaryDate)
    },
    setSelectedYearMonth({commit}, {selectedYearMonth}) {
      commit('setSelectedYearMonth', selectedYearMonth)
    },
    setSelectedDayOrWeek({commit}, {selected}) {
      commit('setSelectedDayOrWeek', selected)
    },
    getSummaryMonth({commit}, {companyId, selectedYearMonth}) {
      if (this.state.mSummaryMonthUnsubscribeObject) { this.state.mSummaryMonthUnsubscribeObject() }
      this.state.mSummaryMonthUnsubscribeObject = fc.companies.doc(companyId).collection("Summaries").doc(selectedYearMonth)
        .onSnapshot((summary) => {
          let summaryMonth = summary.data() ? summary.data() : {salesAmount: 0, salesTaxAmount: 0};
          commit('setSummaryMonth', summaryMonth)
        })
    },
    getSummaryAll({commit}, {companyId}) {
      if (this.state.mSummaryAllUnsubscribeObject) { this.state.mSummaryAllUnsubscribeObject() }
      this.state.mSummaryAllUnsubscribeObject = fc.companies.doc(companyId).collection("Summaries").doc('all')
        .onSnapshot((summary) => {
          let summaryAll = summary.data() ? summary.data() : {salesAmount: 0, salesTaxAmount: 0};
          commit('setSummaryAll', summaryAll)
        })
    },
    getSummaryDateInMount({commit, getters, dispatch}, {companyId, selectedYearMonth, checked}) {
      let preMonth = moment(selectedYearMonth).subtract(1, 'months').format('YYYY-MM').toString()
      let mainChartData = []
      fc.companies.doc(companyId).collection("Summaries").doc(selectedYearMonth).collection("Dates")
        .get().then((summaryList) => {
          if (getters.getSelectedDayOrWeek() === "day") {
            mainChartData = getters.chartDataDay(selectedYearMonth, summaryList)
          } else {
            mainChartData = getters.chartDataWeek(selectedYearMonth, summaryList)
          }
          return mainChartData
        }).then(mainChartData => {
          // checked
          // ถ้าเป็น 0 คือ แสดงเดือนเดียว
          // 1 คือ แสดงเดือนก่อนหน้า
          let comparePreviousMonth = checked === 1
          if (comparePreviousMonth) {
            if (this.state.mSummaryDayFirstUnsubscribeObject) { this.state.mSummaryDayFirstUnsubscribeObject() }
            this.state.mSummaryDayFirstUnsubscribeObject = fc.companies.doc(companyId).collection("Summaries").doc(preMonth).collection("Dates")
              .onSnapshot((summaryList) => {
                if (getters.getSelectedDayOrWeek() === "day") {
                  dispatch('chartDataDayPreviousMonth', {preMonth: preMonth, summaryList: summaryList, mainChartData: mainChartData})
                } else {
                  dispatch('chartDataWeekPreviousMonth', {summaryList: summaryList, mainChartData: mainChartData})
                }
              })
          } else {
            if (this.state.mSummaryDaySecondUnsubscribeObject) { this.state.mSummaryDaySecondUnsubscribeObject() }
            this.state.mSummaryDaySecondUnsubscribeObject = fc.companies.doc(companyId).collection("Summaries").doc(preMonth).collection("Dates")
              .onSnapshot(() => {
                if (getters.getSelectedDayOrWeek() === "day") {
                  commit('setNotPreDayData', mainChartData)
                } else {
                  commit('setNotPreWeekData', mainChartData)
                }
              })
          }
        })
    },
    getSummaryMonthUnsubscribe() {
      if (this.state.mSummaryMonthUnsubscribeObject) {
        this.state.mSummaryMonthUnsubscribeObject()
        this.state.mSummaryMonthUnsubscribeObject = null
      }
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mSummaryAllUnsubscribeObject) {
        this.state.mSummaryAllUnsubscribeObject()
        this.state.mSummaryAllUnsubscribeObject = null
      }
    },
    getSummaryDayFirstUnsubscribe() {
      if (this.state.mSummaryDayFirstUnsubscribeObject) {
        this.state.mSummaryDayFirstUnsubscribeObject()
        this.state.mSummaryDayFirstUnsubscribeObject = null
      }
    },
    getSummaryDaySecondUnsubscribe() {
      if (this.state.mSummaryDaySecondUnsubscribeObject) {
        this.state.mSummaryDaySecondUnsubscribeObject()
        this.state.mSummaryDaySecondUnsubscribeObject = null
      }
    },
    chartDataWeekPreviousMonth({commit}, {summaryList, mainChartData}) {
      let datePreArray = [0, 0, 0, 0, 0, 0, 0, 0]
      summaryList.forEach((doc) => {
        let summary = doc.data()
        summary.id = doc.id
        if (1 <= parseInt(doc.id) && parseInt(doc.id) <= 7)
          (datePreArray[0] = datePreArray[0] + summary.salesAmount / 100)
        else if (8 <= parseInt(doc.id) && parseInt(doc.id) <= 14)
          (datePreArray[1] = datePreArray[1] + summary.salesAmount / 100)
        else if (15 <= parseInt(doc.id) && parseInt(doc.id) <= 21)
          (datePreArray[2] = datePreArray[2] + summary.salesAmount / 100)
        else if (22 <= parseInt(doc.id) && parseInt(doc.id) <= 28)
          (datePreArray[3] = datePreArray[3] + summary.salesAmount / 100)
        else if (29 <= parseInt(doc.id) && parseInt(doc.id) <= 31)
          (datePreArray[4] = datePreArray[4] + summary.salesAmount / 100)
      })
      commit('setPreWeekData', {datePreArray, mainChartData})
    },
    chartDataDayPreviousMonth({commit}, {preMonth, summaryList, mainChartData}) {
      let datePreArray = Array.from(Array(moment(preMonth).daysInMonth()), (_, i) => i - i)
      summaryList.forEach((doc) => {
        let summary = doc.data()
        summary.id = doc.id
        datePreArray[parseInt(doc.id) - 1] = datePreArray[parseInt(doc.id) - 1] + summary.salesAmount / 100
      })
      commit('setPreDayData', {datePreArray, mainChartData})
    }
  },
  getters: {
    getSelectedDayOrWeek: state => () => {
      return state.selectedDayOrWeek;
    },
    chartDataDay: () => (selectedYearMonth, summaryList) => {
      let dateArray = Array.from(Array(moment(selectedYearMonth).daysInMonth()), (_, i) => i - i)
      summaryList.forEach((doc) => {
        let summary = doc.data()
        summary.id = doc.id
        dateArray[parseInt(doc.id) - 1] = dateArray[parseInt(doc.id) - 1] + summary.salesAmount / 100
      })
      return dateArray
    },
    chartDataWeek: () => (selectedYearMonth, summaryList) => {
      let dateArray = [0, 0, 0, 0, 0, 0, 0, 0]
      summaryList.forEach((doc) => {
        let summary = doc.data()
        summary.id = doc.id
        if (1 <= parseInt(doc.id) && parseInt(doc.id) <= 7)
          (dateArray[0] = dateArray[0] + summary.salesAmount / 100)
        else if (8 <= parseInt(doc.id) && parseInt(doc.id) <= 14)
          (dateArray[1] = dateArray[1] + summary.salesAmount / 100)
        else if (15 <= parseInt(doc.id) && parseInt(doc.id) <= 21)
          (dateArray[2] = dateArray[2] + summary.salesAmount / 100)
        else if (22 <= parseInt(doc.id) && parseInt(doc.id) <= 28)
          (dateArray[3] = dateArray[3] + summary.salesAmount / 100)
        else if (29 <= parseInt(doc.id) && parseInt(doc.id) <= 31)
          (dateArray[4] = dateArray[4] + summary.salesAmount / 100)
      })
      return dateArray
    }
  }

}
